export default "__VITE_ASSET__DqGkXfKb__"